export default "__VITE_ASSET__DHJDMN_l__"